import * as React from 'react';
import Checkbox from '@mulesoft/anypoint-components/lib/Checkbox';
import './NewAppsCloudHubEnableCheckbox.css'
import Label from '@mulesoft/anypoint-components/lib/Label';

type EventProps = {
  isLoading: boolean
  isChanging: boolean
  newAppsAgentEnabled: boolean
  onChangeEnabledCheckbox: (e: { value: boolean }) => void
}

export type ModalProps = EventProps

export const NewAppsCloudHubEnableCheckbox = (props: ModalProps) => {
  return (
    <div className="settings-enable-ch-apps-container" data-test-id="settings-enable-ch-apps-container">
      <div className="settings-enable-ch-apps-container-header">
        <h4 className="settings-enable-ch-apps-container-title" data-test-id="settings-enable-ch-apps-container-title">
          Configure Anypoint Monitoring for new CloudHub applications
        </h4>
        <p className="settings-enable-ch-apps-container-subtitle" data-test-id="settings-enable-ch-apps-container-subtitle">
          Configure Anypoint Monitoring to be enabled by default
          for all new CloudHub applications right after deployment.
          You can also manually enable or disable individual apps whenever needed.
        </p>
      </div>
      <div className="settings-enable-ch-apps">
        <Checkbox
          className={`settings-enable-ch-apps-checkbox ${props.isChanging && 'disabled-checkbox'}`}
          testId="settings-enable-ch-apps-checkbox"
          onChange={props.onChangeEnabledCheckbox}
          label="Enable Anypoint Monitoring for newly deployed CloudHub applications."
          indeterminate={props.isLoading}
          disabled={props.isChanging}
          checked={props.newAppsAgentEnabled}
        />
        <div
          className={`settings-enable-ch-apps-label-container ${props.isChanging && 'disabled-label'}`}
          data-test-id="settings-enable-ch-apps-label-container"
        >
          <Label
            className="settings-enable-ch-apps-label-text"
            text="This does not apply to the applications that are already deployed."
          />
        </div>
      </div>
    </div>
  )
}
